import React from 'react'
import { ExclusiveListing } from '../components/ExclusiveListing'
import { PlayVideo } from '../components/PlayVideo'

const AboutInfo = () => {
    const backgroundImage='/assets/images/globCollective.jpg'
  return (
    <div className='bg-dark'>
        <div className="video-container" style={{ marginTop: "0", padding: "100px 20px" }}>
        {/* Background Image */}
        <img className='video-background' src={backgroundImage} alt='background-image'/>

        {/* Content Overlay */}
        <div className="content">
            <h1>Alex Turner</h1>
            <strong>With over $8 Billion in sales, Alex Turner has developed a global<br/> reputation as the top Los Angeles & Beverly Hills real estate agent.</strong>
        </div>
        </div>

        <div class="flex bg-dark font-sans"> 
            <div class="flex-none float-left w-50 ms-5 mt-5 relative">
                <img src="/assets/images/agent.jpg" alt="" class="absolute inset-0 mt-4 w-100 h-75 object-cover" loading="lazy" />
            </div>
            <div className='content mt-5'>
                <h1 className='text-center'>
                GET TO KNOW ME</h1><hr  style={{color:' #dc7d4a', height:'3px',backgroundColor:' #dc7d4a'}}/>
                <p className="text-left pt-5 ps-5">
                Alex Turner is a highly acclaimed real estate agent in the luxury housing market, celebrated for his exceptional 
                professionalism, integrity, and loyalty. Renowned among peers and clients alike, Alex is currently ranked as the #1 
                Luxury Real Estate Agent in New York City and holds a position in the Top 10 Agents Worldwide for global real estate 
                transactions. Over his illustrious career, Alex has achieved over $7 Billion in sales volume, representing some of 
                the most prestigious homes across Manhattan, Hamptons, and other affluent neighborhoods.
                </p>
                <p className="text-left ps-5">In 2024 alone, Alex was responsible for 20% of all luxury properties sold in excess of $15 Million across New York’s 
                    most sought-after locations. This included his representation in the record-breaking $110 Million sale of a 
                    penthouse overlooking Central Park. An expert in high-end properties, Alex specializes in meeting the unique needs 
                    of buyers and sellers in neighborhoods such as Manhattan, Upper East Side, Tribeca, and Southampton. His 
                    unparalleled market knowledge and strong global connections have earned him the title of International Luxury 
                    Ambassador, fostering alliances across global markets and spearheading his signature brand, Alex Turner Global
                     Realty. Through this initiative, Alex ensures his listings reach an elite audience worldwide, showcasing 
                     properties with cutting-edge marketing and state-of-the-art digital strategies.
                </p>

                <p className="text-left ps-5">
                With over 25 years of experience, Alex is recognized as one of the most reliable and admired real estate professionals
                 in the industry. His clientele includes celebrities, CEOs, and high-net-worth individuals seeking confidentiality, 
                 trust, and exceptional service. Alex leads a team of seasoned experts who provide seamless support to clients, 
                 ensuring every transaction is executed with precision and care.
                </p>
                <p className="text-left ps-5">
                Alex is a proud father to three children—Sophia, Mason, and Lila—who are actively pursuing careers in real estate,
                 architecture, and social media branding. Alex works closely with his wife, Rachel Turner, an accomplished luxury 
                 home interior designer. Together, they collaborate on projects, blending architectural elegance with modern living 
                 solutions for their clients.
                </p>
                
            </div>
            
        </div>
        
        <div className='bg-dark text-white text-center'>
        <hr className='ms-5 me-5 ' style={{color:' #dc7d4a', height:'3px',backgroundColor:' #dc7d4a'}}/>
        <h1 className='m-5'>Global Realty Partners</h1>
        <div className='row mb-5 p-5'>
            <div className='col-3'>
                <h5>Primary Phone</h5>
                <p>123-456-7890</p>
            </div>
            <div className='col-3'>
                <h5>Website</h5>
                <a href='#home' className='link link-hover'>http://alexturnerabc.com</a>
            </div>
            <div className='col-3'>
                <h5>License Number</h5>
                <p>#12345678</p>
            </div>
            <div className='col-3'>
                <h5>Email</h5>
                <a href='#home' className="link link-hover">alexturner@abc.com</a>
            </div>
        </div>
        <div className='flex ms-5 p-3 mb-5'>
            <h1 className='display-2'>Getting To Know Alex Turner  |</h1>
            <p className='mt-4 ms-5'>THE $8 BILLION MAN</p>
        </div>
        </div>
        <PlayVideo/>
        <ExclusiveListing/>
    </div>
  )
}

export default AboutInfo